export default __webpack_public_path__ + "static/8-3de96d96d5754e8e30003f874f31ae29.jpg";